export var BmpCompression;
(function (BmpCompression) {
    BmpCompression[BmpCompression["NONE"] = 0] = "NONE";
    BmpCompression[BmpCompression["BI_RLE8"] = 1] = "BI_RLE8";
    BmpCompression[BmpCompression["BI_RLE4"] = 2] = "BI_RLE4";
    BmpCompression[BmpCompression["BI_BIT_FIELDS"] = 3] = "BI_BIT_FIELDS";
    BmpCompression[BmpCompression["BI_ALPHA_BIT_FIELDS"] = 6] = "BI_ALPHA_BIT_FIELDS";
})(BmpCompression || (BmpCompression = {}));
//# sourceMappingURL=types.js.map